export default {
  emits: ['close'],
};
